import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import logoImage from '../../img/logo.png';
import './LegalPages.css';

const DataDeletionPage = () => {
  useEffect(() => {
    document.title = 'Exclusão de Dados | Fluxo Clínica';
  }, []);

  return (
    <div className="legal-page">
      <div className="legal-page__container">
        <header className="legal-page__header">
          <Link to="/inicio" aria-label="Ir para a página inicial do Fluxo Clínica">
            <img src={logoImage} alt="Fluxo Clínica" className="legal-page__logo" />
          </Link>
          <Link to="/inicio" className="legal-page__back">Voltar ao site</Link>
        </header>

        <main className="legal-page__content">
          <h1>Instruções para Exclusão de Dados</h1>
          <p className="legal-page__updated">Última atualização: 26 de agosto de 2026.</p>

          <p>
            Você pode solicitar a exclusão de dados pessoais tratados pelo Fluxo Clínica,
            inclusive dados associados a uma integração com Meta ou Instagram.
          </p>

          <h2>Como solicitar</h2>
          <ol>
            <li>
              Envie um e-mail para{' '}
              <a href="mailto:reinaldofp@gmail.com?subject=Solicitação%20de%20exclusão%20de%20dados">
                reinaldofp@gmail.com
              </a>.
            </li>
            <li>Use o assunto <strong>Solicitação de exclusão de dados</strong>.</li>
            <li>
              Informe seu nome, e-mail de contato, nome da clínica relacionada e, quando se
              tratar do Instagram, o nome de usuário da conta envolvida.
            </li>
            <li>Descreva quais dados ou integração deseja excluir.</li>
          </ol>

          <h2>Confirmação da identidade</h2>
          <p>
            Para proteger os titulares, poderemos solicitar informações adicionais para
            confirmar a identidade, a titularidade da conta ou a autorização para representar
            uma clínica. Nunca solicitaremos sua senha do Instagram, Facebook ou Fluxo Clínica.
          </p>

          <h2>Como a solicitação será tratada</h2>
          <p>
            Após a validação, localizaremos os dados abrangidos, avaliaremos as obrigações
            legais aplicáveis e informaremos as providências adotadas. Quando a clínica for a
            controladora dos dados, a solicitação poderá ser encaminhada à clínica ou atendida
            conforme suas instruções.
          </p>

          <h2>Dados que podem precisar ser mantidos</h2>
          <p>
            Alguns registros poderão ser preservados quando necessários ao cumprimento de
            obrigação legal ou regulatória, à guarda obrigatória de prontuários, ao exercício
            regular de direitos, à prevenção de fraudes ou à segurança. Quando possível, os
            dados serão bloqueados ou anonimizados durante o período de retenção aplicável.
          </p>

          <h2>Desconectar o Instagram</h2>
          <p>
            A clínica também pode revogar o acesso do aplicativo nas configurações da Meta ou
            do Instagram e solicitar a remoção da conexão no Fluxo Clínica. A revogação impede
            novos acessos, mas não elimina automaticamente registros que devam ser mantidos por
            obrigação legal ou solicitação da clínica controladora.
          </p>

          <div className="legal-page__notice">
            Consulte a <Link to="/politica-de-privacidade">Política de Privacidade</Link> para
            entender como e por que os dados são tratados.
          </div>
        </main>

        <footer className="legal-page__footer">© 2026 Fluxo Clínica.</footer>
      </div>
    </div>
  );
};

export default DataDeletionPage;
